<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>
    <onaydialog ref="onaydialog"></onaydialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <saticiodemedialog
      ref="saticiodemedialog"
      v-model="Rapor"
    ></saticiodemedialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{this.$t('Payments-Made-to-the-Seller')}}</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-tooltip bottom>
                <v-btn
                  :disabled="!sayfayetki.Save"
                  slot="activator"
                  @click="odemeEkle()"
                  flat
                >
                  <span class="hidden-sm-and-down">
                    <span class="hidden-sm-and-down">{{ $t('Add-v2', { value: $t('Payment')}) }} </span>
                  </span>
                  <v-icon right dark>add_box</v-icon>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{ $t('Add-v2', { value: $t('Invoice-Received')}) }} </span>
              </v-tooltip>

           
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-layout row wrap>
              <v-flex pb-3 xs12 sm12 md12>
                <v-card flat>
                  <v-form ref="formsaticilar" v-model="valid" lazy-validation>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 pt-2 pb-2 pl-1 md2>
                        <pnrbul v-model="Rapor.PnrNo" hide-details> </pnrbul>
                      </v-flex>

                      <v-flex pt-2>
                        <v-layout>
                          <div v-if="load1">
                            <v-btn
                              color="info"
                              @click="getList()"
                              fab
                              small
                              dark
                            >
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout pt-3 align-center>
                              <v-progress-circular
                                indeterminate
                                :width="4"
                                color="blue"
                              ></v-progress-circular>
                            </v-layout>
                          </div>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm6 pt-2 pb-2 pl-1 md2>
                        <parainput
                          :isPositive="true"
                          :aktif="true"
                          :simge="PB"
                          v-model="Rapor.ToplamMaliyet"
                          :etiket="$t('Total-Expenses')"
                          :autocomplete="'autocomplete'"
                        ></parainput>
                      </v-flex>
                      <v-flex xs12 sm6 pt-2 pb-2 pl-1 md2>
                        <parainput
                          :isPositive="true"
                          :aktif="true"
                          :simge="PB"
                          v-model="Rapor.ToplamOdeme"
                          :etiket="$t('Total-Payment')"
                          :autocomplete="'autocomplete'"
                        ></parainput>
                      </v-flex>
                      <v-flex xs12 sm6 pt-2 pb-2 pl-1 md2>
                        <parainput
                          :isPositive="true"
                          :aktif="true"
                          :simge="PB"
                          v-model="Rapor.ToplamIade"
                          :etiket="$t('Total-Return')"
                          :autocomplete="'autocomplete'"
                        ></parainput>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-card>
              </v-flex>

              <v-flex xs12 sm12 md12 pb-3>
                <v-card flat class="white--text">
                  <v-card flat>
                    <v-card-actions>
                      <v-layout row wrap>
                        <v-flex xs12 sm12>
                          <v-card flat>
                            <v-data-table
                              :headers="headersgelen"
                              :rows-per-page-items="[20, 100]"
                              :items="Rapor.itemsodeme"
                              :search="searchsatilanbilet"
                            >
                              <template slot="items" slot-scope="props">
                                <tr item>
                                  <td class="text-xs-left">
                                    {{ props.item.HesapKodu }}
                                  </td>
                                  <td class="text-xs-left">
                                    {{ props.item.BA }}
                                  </td>
                                  <td class="text-xs-center">
                                    {{ props.item.Tarih | dateformat }}
                                  </td>
                                  <td class="text-xs-center">
                                    {{ props.item.Evraktipi }}
                                  </td>
                                  <td class="text-xs-right">
                                    {{ props.item.Tutar | moneyformat }}
                                  </td>
                                  <td class="text-xs-center">
                                    {{ props.item.DovizCinsi }}
                                  </td>
                                  <td class="text-xs-right">
                                    {{ props.item.DovizTutar | moneyformat }}
                                  </td>
                                  <td class="text-xs-right">
                                    {{ props.item.Kur | moneyformat }}
                                  </td>
                                  <td class="text-xs-left">
                                    {{ props.item.SaticiTip }}
                                  </td>
                                  <td class="text-xs-left">
                                    {{ props.item.SaticiKod }}
                                  </td>
                                  <td class="text-xs-center">
                                    {{ props.item.Donem1 | dateformat }}
                                  </td>
                                  <td class="text-xs-center">
                                    {{ props.item.Donem2 | dateformat }}
                                  </td>
                                  <td class="text-xs-center">
                                    {{ props.item.CoIslemTip }}
                                  </td>
                                  <td class="text-xs-right">
                                    <v-btn
                                      icon
                                      class="mx-0"
                                      @click="OdemeSil(props.item)"
                                    >
                                      <v-icon color="pink">delete</v-icon>
                                    </v-btn>
                                    <v-btn
                                      icon
                                      class="mx-0"
                                      @click="OdemeDuzenle(props.item)"
                                    >
                                      <v-icon color="teal">edit</v-icon>
                                    </v-btn>
                                  </td>
                                </tr>
                              </template>
                              <v-alert
                                slot="no-results"
                                :value="true"
                                color="error"
                                icon="warning"
                              >
                                {{ $t('No-records-searched-for', { value: searchsatilanbilet}) }} 
                              </v-alert>
                            </v-data-table>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>

          <v-snackbar
            :timeout="timeout"
            :top="y === 'top'"
            :bottom="y === 'bottom'"
            :right="x === 'right'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :vertical="mode === 'vertical'"
            v-model="snackbar"
          >
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false"
              >{{$t('Close')}}</v-btn
            >
          </v-snackbar>

          <v-dialog
            v-model="dialogfiltre"
            scrollable
            persistent
            max-width="500px"
          >
            <v-card flat color="grey lighten-4">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md12 pa-1>
                    <v-card flat class="white--text">
                      <v-card flat color="grey lighten-5">
                        <v-card-actions>
                          <v-layout row wrap>
                            <v-flex md12 xs12 sm12>
                              <pnrbul
                                v-model="GelenFaturaParams.PNR_No"
                                hide-details
                              >
                              </pnrbul>
                            </v-flex>

                            <v-flex md6 xs12 sm6>
                              <v-select
                                clearable
                                :items="itemssaticitip"
                                item-text="Aciklama"
                                item-value="Kod"
                                v-model="GelenFaturaParams.SaticiTip"
                                :label="$t('Seller-Type')"
                                hide-details=""
                              >
                              </v-select>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <genelarama
                                :autofocuss="true"
                                apiname="SaticiAra"
                                :tip="Rapor.PSaticiTip"
                                :label="$t('Seller-Code')"
                                v-model="GelenFaturaParams.SaticiKod"
                              ></genelarama>
                            </v-flex>
                            <v-flex pl-1 xs12 sm12 md12>
                              <genelarama
                                apiname="MasrafMerkeziAra"
                                :label="$t('Expense-Center-v2')"
                                v-model="GelenFaturaParams.MasrafMerkezi"
                              ></genelarama>
                            </v-flex>
                            <v-flex pl-1 xs12 sm12 md12>
                              <geneltipara
                                v-model="GelenFaturaParams.AcenteDepartmanID"
                                tip="AcenteDepartman"
                              >
                              </geneltipara>
                            </v-flex>
                            <v-checkbox
                              v-model="GelenFaturaParams.Proforma"
                              label="Proforma"
                              hide-details
                            >
                            </v-checkbox>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  flat
                  @click.native="filtreiptal()"
                  >{{ $t("cancel_button") }}</v-btn
                >
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()"
                  >{{ $t('Apply-Filters') }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
import auth from "../../../../api/auth";
import tarihcomp from "../../customcomp/tarihim";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tool from "../../coper/tools";
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
import anatip from "@/components/app/coper/comp/anatip.vue";
import rez from "../rezervasyon";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue";
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
import parainput from "../../customcomp/parainput";
import onaydialog from "@/components/app/customcomp/onaydialog.vue";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import saticiodemedialog from "@/components/app/coper/component/saticiodemedialog";

export default {
  data() {
    return {
       PB: "TL",
      disabledtest: false,
      timeout: null,

      odemeData: {},
      loadingvmodel: false,
      Rapor: {
        PnrNo: null,
        ToplamIade: 0,
        ToplamMaliyet: 0,
        ToplamOdeme: 0,
        itemsodeme: [],
      },

      GelenFaturaParams: {
        GelenFaturaTarih1: null,
        GelenFaturaTarih2: null,
        SatisFaturaTarih1: null,
        SatisFaturaTarih2: null,
        GelenFaturaKayitTarih1: null,
        GelenFaturaKayitTarih2: null,
        SaticiTip: null,
        SaticiKod: null,
        PNR_No: null,
        MasrafMerkezi: null,
        AcenteDepartmanID: null,
        Proforma: false,
      },

      GelenFatura: {
        KayitTipi: 1,
        Fatura: {
          SaticiTip: 1,
          SaticiKod: null,
          FatSeri: null,
          FatNo: null,
          FatTarih: null,
          FatPara: null,
          FatKur: 0,
          SatisPara: null,
          SatisKur: 0,
          VadeTarihi: null,
          HesaplananVade: null,
          FaturaTip: 0,
          MasrafMrkz: null,
          Proforma: false,
          Aciklama: null,
          MuhasebeFisTipi: {
            id: null,
            kod: null,
            isim: null,
            tip: null,
          },
          TransferKod: {
            id: null,
            kod: null,
            isim: null,
            tip: null,
          },
          Kalemler: [],

          ToplamTutar: 0,
          ToplamKDVliTutar: 0,
          ToplamKDVTutar: 0,
          ToplamTevkifatTutar: 0,
          ToplamStopajTutar: 0,
          FaturaNetTutar: 0,
          Satici: {
            id: null,
            kod: null,
            isim: null,
            tip: null,
            YurtIci_YurtDisi: 0,
            CariKod: null,
          },
        },
      },

      itemssaticitip: rez.SaticiTip,
      itemsicdis: rez.IcDis,
      itemsopsiyon: rez.Opsiyon,
      itemstarihtip: [
        {
          text: this.$t('Registration-Date'),
          value: 0,
        },
        {
          text: this.$t('Sales-Invoice-Date'),
          value: 1,
        },
        {
          text: this.$t('Invoice-Date'),
          value: 2,
        },
      ],

      itemskomisyon: [
        {
          text: this.$t('None'),
          value: false,
        },
        {
          text: this.$t('Available'),
          value: true,
        },
        {
          text: this.$t('All-v2'),
          value: null,
        },
      ],
      tarihTip: 0,

      sayfayetki: {
        Screen: true,
        Update: true,
        Save: true,
        Delete: true,
        Status: true,
        Message: null,
        islem: 0,
      },
      filtrevarmi: false,
      search: "",
      searchsatilanbilet: null,
      searchiadebilet: null,
      searchvoid: null,

      headersgelen: [
        {
          text: this.$t('Accound-Code'),
          value: "HesapKodu",
          width: "5%",
          align: "left",
        },
        {
          text: "BA",
          value: "BA",
          width: "5%",
          align: "left",
        },

        {
          text: this.$t('Date'),
          value: "Tarih",
          width: "5%",
          align: "left",
        },
        {
          text: this.$t('Document-Type'),
          value: "Evraktipi",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Amount'),
          value: "Tutar",
          width: "5%",
          align: "right",
        },
        {
          text: this.$t('Type-of-currency'),
          value: "DovizCinsi",
          width: "5%",
          align: "left",
        },
        {
          text: this.$t('Currency-Amount'),
          value: "DovizTutar",
          width: "5%",
          align: "left",
        },
        {
          text: this.$t('Exchange-Rate-v2'),
          value: "Kur",
          width: "5%",
          align: "left",
        },
        {
          text: this.$t('Seller-Type'),
          value: "SaticiTip",
          width: "5%",
          align: "left",
        },
        {
          text: this.$t('Seller-Code'),
          value: "SaticiKod",
          width: "5%",
          align: "left",
        },
        {
          text: "C-IN",
          value: "Donem1",
          width: "5%",
          align: "center",
        },
        {
          text: "C-OUT",
          value: "Donem2",
          width: "5%",
          align: "center",
        },
        {
          text: this.$t('Process-Type'),
          value: "CoIslemTip",
          width: "5%",
          align: "left",
        },
        {
          text: "",
          value: "",
          width: "10%",
          align: "",
        },
      ],

      KayitTarihiBasla: null,
      KayitTarihiBitis: null,
      itemsairlinelist: [],
      hesapgurubu: [],
      masrafmerkezi: [],
      doviztipi: [],
      valid: true,
      tumsirketler: "",
      totalCount: 0,
      totalService: 0,
      totalAmount: 0,
      StartDate: null,
      EndDate: null,
      date: null,
      menu: false,
      modal: false,
      dateFormatted: "",
      date2: null,
      menu2: false,
      dateFormatted2: "",
      modal2: false,
      loading: false,
      items: [],
      load: false,
      load1: true,
      search3: "",

      renk1: "info",
      dialogfiltre: false,
      hesapkodu: [],
      kredikarti: [],
      statecari: [],
      searchcari: "",
      progress: false,
      tooltip: false,
      el: null,
      yok: false,
      itemsiade: [],
      itemsvoid: [],

      butondurum: true,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",
      dictionary: {
        custom: {
          tarihsec: {
            required: () => this.$t('Please-select-a-date'),
          },
          tarihsec1: {
            required: () => this.$t('Please-select-a-date'),
          },
        },
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  beforeMount: beforeMount,
  mounted() {
    this.$validator.localize("en", this.dictionary);
    var pb = null; // credentials'tan gelecek

  try {
    var raw = window.localStorage.getItem("credentials");
    if (raw) {
      var c = JSON.parse(raw);

      // Optional chaining'siz, eski JS ile sırayla dene
      pb =
        (c && c.ParaBirimi) ||
        (c && c.paraBirimi) ||
        (c && c.currency) ||
        (c && c.Currency) ||
        (c && c.user && c.user.currency) ||
        (c && c.settings && c.settings.currency) ||
        null;
    }
  } catch (e) {
    // parse hatası vb. durumlarda pb null kalır
  }

  // Değer yoksa TL; varsa geleni kullan (normalize: trim + upper)
  this.PB =
    pb === null || pb === undefined || pb === ""
      ? "TL"
      : String(pb).toUpperCase().trim();

  // İlk oluşturma ise alanlara yaz
  if (this.val && this.val.islem === "new") {
    this.val.kalem.satisPara.paraBirimi    = this.PB;
    this.val.kalem.komisyonPara.paraBirimi = this.PB;
    this.val.kalem.alisPara.paraBirimi     = this.PB;
  }
    

    //  this.el = this.$refs.fab.$el;

    // this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

    // if (this.sayfayetki.Status == true) {

    // } else {

    //   this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

    //     if (sonuc == true) {

    //       if (this.prevRoute != null) {
    //         var url = '#' + this.prevRoute

    //         window.open(url, '_self')
    //       } else {
    //         var url = '#/'
    //         window.open(url, '_self')
    //       }
    //     } else {

    //     }

    //   });

    // }

    
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },

  components: {
    tarihcomp: tarihcomp,
    yetkidialog,
    hatadialog,
    anatip,
    genelarama,
    referansmerkezicomp,
    pnrbul,
    geneltipara,
    parainput,
    onaydialog,
    loadingcomp,
    saticiodemedialog,
  },
  watch: {},
  beforeDestroy() {
    // clear the timeout before the component is destroyed
    clearTimeout(this.timeout);
  },
  methods: {
    OdemeDuzenle(item) {
      if (this.Rapor.PnrNo != null && this.Rapor.PnrNo != "") {
        this.$refs.saticiodemedialog
          .open("update", this.Rapor.PnrNo, item)
          .then((sonuc) => {
            if (sonuc == true) {
             this.getList();
            }
          });
      } else {
        this.text1 = this.$t('Please-enter-PNR-number');
        this.snackbar = true;
      }
    },
    delaytest() {
      this.disabledtest = true;

      // Re-enable after 5 seconds
      // this.timeout = setTimeout(() => {
      //   this.disabledtest = false
      // }, 5000)

      this.myFunction();
    },
    myFunction() {
      this.disabledtest = false;
    },

    getparabirimi() {
      return helpers.getparabirimi();
    },
    odemeEkle() {
      if (this.Rapor.PnrNo != null && this.Rapor.PnrNo != "") {
        this.$refs.saticiodemedialog
          .open("ekle", this.Rapor.PnrNo, null)
          .then((sonuc) => {
            if (sonuc == true) {
              this.getList();
            }
          });
      } else {
        this.text1 = this.$t('Please-enter-PNR-number');
        this.snackbar = true;
      }
    },
    OdemeSil(val) {
      this.$refs.onaydialog
        .open("Bu kayıtı silmek istediğinize emin misiniz?", 1)
        .then((sonuc) => {
          if (sonuc == true) {
            this.loadingvmodel = true;
            let params = {
              Odeme: val,
            };

            tool.http_post(this, "SaticiOdemeSil", params).then(
              (response) => {
                this.loadingvmodel = false;
                if (response.body.Status == true) {
                  this.text1 = "Silme işleminiz gerçekleşti.";
                  this.snackbar = true;
                  this.getLi;
                } else {
                  this.text1 = response.body.ErrorList[0];
                  this.snackbar = true;
                }
              },

              (response) => {
                this.loadingvmodel = false;
               this.text1 = $t('Error-Occured-Please-Try-Again')
                this.snackbar = true;
              }
            );
          }
        });
    },
    HataYonetimi(response, request, baslik) {
      if (response.status === 500) {
        //Internal Server Error
        this.$refs.hatadialog.open(response, request, baslik);
      } else {
        this.text1 = "Service Unavailable -" + baslik;
        this.snackbar = true;
      }
    },

    git(val) {
      var url =
        "#/fatura/copergelenfatura/id?islem=get&st=" +
        val.SaticiTip +
        "&sk=" +
        val.SaticiKod +
        "&fs=" +
        val.FatSeri +
        "&fn=" +
        val.FatNo +
        "&ft=" +
        val.Tarih;
      window.open(url, "_target");
    },
    getList: getList,
    filtrele: filtrele,
    filtrekayit: filtrekayit,
    filtreiptal: filtreiptal,
  },
};

function filtrele() {
  this.dialogfiltre = true;
}

function filtrekayit() {
  this.filtrevarmi = true;
  this.dialogfiltre = false;
  this.getList();
}

function filtreiptal() {
  this.filtrevarmi = false;
  this.dialogfiltre = false;

  this.GelenFaturaParams.GelenFaturaTarih1 = null;
  this.GelenFaturaParams.GelenFaturaTarih2 = null;
  this.GelenFaturaParams.SatisFaturaTarih1 = null;
  this.GelenFaturaParams.SatisFaturaTarih2 = null;
  this.GelenFaturaParams.GelenFaturaKayitTarih1 = null;
  this.GelenFaturaParams.GelenFaturaKayitTarih2 = null;
  this.GelenFaturaParams.SaticiTip = null;
  this.GelenFaturaParams.SaticiKod = null;
  this.GelenFaturaParams.PNR_No = null;
  this.GelenFaturaParams.MasrafMerkezi = null;
  this.GelenFaturaParams.AcenteDepartmanID = null;
  this.GelenFaturaParams.Proforma = false;
}

function getList() {
  if (this.Rapor.PnrNo != null && this.Rapor.PnrNo != "") {
    this.load1 = false;
    this.progress = true;

    let params = {
      PNR_No: this.Rapor.PnrNo,
    };

    tool.http_post(this, "SaticiOdemeList", params).then(
      (response) => {
        this.load1 = true;
        this.progress = false;

        if (response.body.Status == true) {
          this.Rapor.itemsodeme = response.body.data.OdemeListesi;
          this.Rapor.ToplamIade = response.body.data.ToplamIade;
          this.Rapor.ToplamMaliyet = response.body.data.ToplamMaliyet;
          this.Rapor.ToplamOdeme = response.body.data.ToplamOdeme;
        } else {
          this.text1 = response.body.ErrorList[0];
          this.snackbar = true;
        }
      },

      (response) => {
       this.text1 = $t('Error-Occured-Please-Try-Again')
        this.snackbar = true;
        this.load1 = true;
        this.progress = false;
      }
    );
  } else {
    this.text1 = this.$t('Please-enter-PNR-number');
    this.snackbar = true;
  }
}

function beforeMount() {}
</script>
<style>
</style>